import { configureStore, Tuple } from '@reduxjs/toolkit';
import logger from 'redux-logger';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import reducers from './reducers';

const persistConfig = {
  key: 'root',
  storage,
  blacklist: ['metrics']
};

const persistedReducer = persistReducer(persistConfig, reducers());

const store = configureStore({
  reducer: persistedReducer,
  middleware: () => new Tuple(logger),
  devTools: process.env.REAC_APP_NODE_ENV !== 'production',
});
const persistor = persistStore(store);

export { store, persistor };
